import axios from 'axios'
import { config, url } from '@/store'

const getAll = () => {
  const defaultFilter = 'search[type]=Poll'
  const expands = 'expand=itemable,owner'
  return axios.get(`${url}/event-items?${defaultFilter}&${expands}`, config)
}

const getPollAnswers = (pollId) => {
  return axios.get(`${url}/poll-answers?search[poll_id]=${pollId}`, config)
}

const getSingle = (id) => {
  const expands = 'expand=options,settings'
  return axios.get(`${url}/polls/${id}?${expands},`, config)
}

const create = (postData) => {
  return axios.post(`${url}/polls`, postData, config)
}

const createOption = (postData) => {
  return axios.post(`${url}/poll-options`, postData, config)
}

const updateOption = (params) => {
  return axios.put(`${url}/poll-options/${params.id}`, params.updateData, config)
}

const removeOption = (id) => {
  return axios.delete(`${url}/poll-options/${id}`, config)
}

const createAnswer = (postData) => {
  return axios.post(`${url}/poll-answers`, postData, config)
}

const update = (params) => {
  return axios.put(`${url}/polls/${params.id}`, params.updateData, config)
}

const remove = (id) => {
  return axios.delete(`${url}/event-items/${id}`, config)
}

export default {
  getAll,
  getPollAnswers,
  getSingle,
  create,
  createOption,
  updateOption,
  removeOption,
  createAnswer,
  update,
  remove
}
